export default __webpack_public_path__ + "static/media/solarlight.7cefd59a.png";